export const SET_PAGE_TITLE = 'SET_PAGE_TITLE';
export const SET_USER_ID_CLAIMS_NAME = 'SET_USER_ID_CLAIMS_NAME';
export const SET_IS_APP_READY = 'SET_IS_APP_READY';

export interface IGeneralState {
  pageTitle: string;
  userIdClaimsName: string;
  isAppReady: boolean;
}
